import { ExpandMore } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, CardHeader, CircularProgress, Divider, Grid, IconButton, Menu, MenuItem, Modal, Snackbar, Tooltip, Select } from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { DataGrid, GridActionsCellItem, GridRowParams, GridToolbar } from '@mui/x-data-grid';
import { useFormik } from 'formik';
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { api } from '../api';
import AuthContext from "../auth/AuthProvider";
import { fetchToken } from '../auth/Token';
import { FileOpenOutlined } from "@mui/icons-material";
import { toast } from 'sonner';


const AccountActions = ({params, getLoansAccount}) =>{
    const [open, setOpen] = useState(false);
    const {  permissions } = useContext(AuthContext);
    const [loansData, setLoansData] = useState({
        "id": params.row.id,
        "account_name": params.row.account_name,
        "interest_amt": params.row.interest_amt,
        "application_fee": params.row.application_fee,
        "proccessing_fee": params.row.proccessing_fee,
        "min_amt": params.row.min_amt,
        "max_amt": params.row.max_amt,
    })
    
    const [ope, setOpe] = React.useState(false);
    const [message, setMessage] = useState("");

    const handleClo = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpe(false);
    };

    const actio = (
        <React.Fragment>
          <Button color="secondary" size="small" onClick={handleClo}>
            CLOSE
          </Button>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClo}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      );


      const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        if (type === 'checkbox') {
            setLoansData({
                ...loansData,
                [name]: checked,
            });
        } else {
            setLoansData({
                ...loansData,
                [name]: value,
            });
        }
    };

    const createLoans = async (event) => {
        event.preventDefault();
        try {
             await api.post('/account/loan', loansData, {
                headers: {
                    Authorization: 'Bearer '+ fetchToken()
                }
             }).then(function (response) {
                    setMessage(response.data)
                    setOpe(true)
                    setLoansData({
                        "id": params.row.id,
                        "account_name": params.row.account_name,
                        "interest_amt": params.row.interest_amt,
                        "application_fee": params.row.application_fee,
                        "proccessing_fee": params.row.proccessing_fee,
                        "min_amt": params.row.min_amt,
                        "max_amt": params.row.max_amt,
                    })
                    setOpen(false);
                    getLoansAccount();
             })
        } catch(error) {
            console.log(error.data)
        }
    }

    const handleOpen = () =>{
        if (permissions && permissions.update_loan_account === true){
            setOpen(true)
        }else{
            setMessage("Not Authorized")
            setOpe(true)
        }
    };

    return(
        <>
        <IconButton onClick={handleOpen}><EditIcon /></IconButton>
        <Dialog open={open} onClose={()=>setOpen(false)}>
            <DialogTitle>Edit Loans Account</DialogTitle>
            <DialogContent>
            <DialogContentText>
                Changes might take a couple of minutes to activate
                after the setup.
            </DialogContentText>
            <TextField
                required
                margin="dense"
                id="account_name"
                name="account_name"
                label="Account Name"
                onChange={handleInputChange}
                value={loansData.account_name}
                type="text"
                fullWidth
                variant="outlined"
            />
            <TextField
                required
                margin="dense"
                id="interest_amt"
                name="interest_amt"
                type="number"
                value={loansData.interest_amt}
                label="Interest Percentage (%)"
                onChange={handleInputChange}
                fullWidth
                variant="outlined"
            />
            

            <TextField
                required
                margin="dense"
                id="application_fee"
                name="application_fee"
                label="Application Fee"
                onChange={handleInputChange}
                type="number"
                value={loansData.application_fee}
                fullWidth
                variant="outlined"
            />
            <TextField
                required
                margin="dense"
                id="proccessing_fee"
                name="proccessing_fee"
                label="Processing Fee"
                onChange={handleInputChange}
                type="number"
                value={loansData.proccessing_fee}
                fullWidth
                variant="outlined"
            />
            <TextField
                required
                margin="dense"
                id="min_amt"
                name="min_amt"
                label="Minimum Amount"
                onChange={handleInputChange}
                type="number"
                value={loansData.min_amt}
                fullWidth
                variant="outlined"
            />
            <TextField
                required
                margin="dense"
                id="max_amt"
                name="max_amt"
                label="Maximum Amount"
                onChange={handleInputChange}
                type="number"
                value={loansData.max_amt}
                fullWidth
                variant="outlined"
            />
            <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Inflow/Outflow"
                  id="in_out"
                  label="Inflow/Outflow"
                  value={loansData.in_out}
                  onChange={handleInputChange}
                  fullWidth
                  name="in_out"
                >
                    <MenuItem value={'inflow'}>
                      Inflow
                    </MenuItem>
                    <MenuItem value={'outflow'}>
                      Outflow
                    </MenuItem>
                </Select>
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Income/Expenditure"
                  id="in_ex"
                  label="Income/Expenditure"
                  value={loansData.in_ex}
                  onChange={handleInputChange}
                  fullWidth
                  name="in_ex"
                >
                    <MenuItem value={'income'}>
                      Income
                    </MenuItem>
                    <MenuItem value={'expenditure'}>
                      Expenditure
                    </MenuItem>
                    <MenuItem value={'stock'}>
                      Stock
                    </MenuItem>
                </Select>
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Asset/Liability"
                  id="as_li"
                  label="Asset/Liability"
                  value={loansData.as_li}
                  onChange={handleInputChange}
                  fullWidth
                  name="as_li"
                >
                    <MenuItem value={'asset'}>
                      Asset
                    </MenuItem>
                    <MenuItem value={'liability'}>
                      Liability
                    </MenuItem>
                </Select>
            </DialogContent>
            <DialogActions>
            <Button onClick={()=>setOpen(false)}>Cancel</Button>
            <Button onClick={createLoans}>Save Changes</Button>
            </DialogActions>
        </Dialog>
        <Snackbar
            open={ope}
            autoHideDuration={1000}
            onClose={handleClo}
            message={message}
            action={actio}
        />
        </>
    )
};




const LoanAccounts = () => {
    const [allLoans, setAllSLoans] = useState([]);
    const [open, setOpen] = useState(false); 
    const {  permissions } = useContext(AuthContext);
    const navigate = useNavigate();
    const [modal_open, setModal_open] = useState(false)
    const [loansData, setLoansData] = useState({
        "id": null,
        "account_name": '',
        "interest_amt": null,
        "application_fee": null,
        "proccessing_fee": null,
        "min_amt": null,
        "max_amt": null,
        "in_out": "",
        "in_ex": "",
        "as_li": "",
    })
    const [all_societies, setAll_societies] = useState([])
    const [products, setProducts] = useState([])
    const [ope, setOpe] = useState(false);
    const [message, setMessage] = useState("");
    const [commodities, setCommodities] = useState([]);
    const [commodities_ready, setCommodities_ready] = useState(true);
    const [loading, setLoading] = useState(false);
    const [edit_open, setEdit_open] = useState(false);
    const [e_id, setE_Id] = useState(null);
    const [e_type, setE_Type] = useState('');
    const [e_name, setE_Name] = useState('');
    const [crop_id, setCrop_id] = useState(null);
    const [e_price, setE_Price] = useState(null);
    const [e_interest, setE_Interest] = useState(null);
    const [e_quantity, setE_Quantity] = useState(0);
    const [e_company, setE_Company] = useState('');
    const [serviceFields, setServiceFields] = useState([
        {
          index_id: 0,
          service_name: '', 
          service_price: null,
          service_interest: null
        },
    ])
    const [inputFields, setInputFields] = useState([
        {
          index_id: 0,
          input_name: '', 
          input_price: null,
          input_interest: null,
          input_quantity: null,
          input_company: null,
        },
    ])
    const [equipmentsFields, setEquipmentsFields] = useState([
        {
          index_id: 0,
          equipment_name: '', 
          equipment_price: null,
          equipment_interest: null
        },
    ])
    const [anchorEl, setAnchorEl] = useState(null);
    const oppen = Boolean(anchorEl);

    const handleConfirm = (id, name) => {
        navigate('/seasons', {state: { 
            society_id: id,
            name: name 
        }});
    }


    const addServiceFields = () => {
        const maxIndexId = Math.max(...serviceFields.map((field) => field.index_id), 0);
        const nextIndexId = maxIndexId + 1;
    
        let new_object = {
          index_id: nextIndexId,
          service_name: '', 
          service_price: null,
          service_interest: null
        }
        setServiceFields([...serviceFields, new_object])
    }
    
    const removeServiceField = (index_id) => {
        const indexToRemove = serviceFields.findIndex((field) => field.index_id === index_id);
        
        if (indexToRemove !== -1) {
            const updatedFormFields = [...serviceFields];
            updatedFormFields.splice(indexToRemove, 1);
            setServiceFields(updatedFormFields);
        }
    };
    // Equipments
    const addEquipmentFields = () => {
        const maxIndexId = Math.max(...equipmentsFields.map((field) => field.index_id), 0);
        const nextIndexId = maxIndexId + 1;
    
        let new_object = {
          index_id: nextIndexId,
          equipments_name: '', 
          equipments_price: null,
          equipments_interest: null
        }
        setEquipmentsFields([...equipmentsFields, new_object])
    }
    
    const removeEquipmentField = (index_id) => {
        const indexToRemove = equipmentsFields.findIndex((field) => field.index_id === index_id);
        
        if (indexToRemove !== -1) {
            const updatedFormFields = [...equipmentsFields];
            updatedFormFields.splice(indexToRemove, 1);
            setEquipmentsFields(updatedFormFields);
        }
    };
    // Inputs
    const addInputFields = () => {
        const maxIndexId = Math.max(...inputFields.map((field) => field.index_id), 0);
        const nextIndexId = maxIndexId + 1;
    
        let new_object = {
          index_id: nextIndexId,
          input_name: '', 
          input_price: null,
          input_interest: null,
          input_quantity: null,
          input_company: null,
        }
        setInputFields([...inputFields, new_object])
    }
    
    const removeInputField = (index_id) => {
        const indexToRemove = inputFields.findIndex((field) => field.index_id === index_id);
        
        if (indexToRemove !== -1) {
            const updatedFormFields = [...inputFields];
            updatedFormFields.splice(indexToRemove, 1);
            setInputFields(updatedFormFields);
        }
    };


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloses = () => {
        setAnchorEl(null);
    };


    const fetchSocieties = () => {
        const storedSocieties = localStorage.getItem('all_societies');
      
        // Check if societies data is already in local storage
        if (storedSocieties) {
          setAll_societies(JSON.parse(storedSocieties));
        } else {
          api
            .get('/association/societies/allshch', {
              headers: {
                Authorization: 'Bearer ' + fetchToken(),
              },
            })
            .then(function (response) {
              setAll_societies(response.data?.Society);
              // Store the response in local storage
              localStorage.setItem('all_societies', JSON.stringify(response.data?.Society));
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      };

      const fetchProducts = () => {
        const storedProducts = localStorage.getItem('all_products');
      
        // Check if products data is already in local storage
        if (storedProducts) {
          setProducts(JSON.parse(storedProducts));
        } else {
          api
            .get('/association/production/loan/view/all', {
              headers: {
                Authorization: 'Bearer ' + fetchToken(),
              },
            })
            .then(function (response) {
              setProducts(response.data?.data);
              // Store the response in local storage
              localStorage.setItem('all_products', JSON.stringify(response.data?.data));
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      };
      
      

    useEffect(() => {
        fetchProducts()
        fetchSocieties();
    },[])

    const formik = useFormik({
        initialValues: {
            "society_id": null,
            "crop_id": null,
        },
        validationSchema: Yup.object({
            "crop_id": Yup.string().required("Specify Crop"),
        }),
        onSubmit: (values) => {
            const data = {
                'commodity_id': values.crop_id,
                'services': serviceFields,
                'inputs': inputFields,
                'equipments': equipmentsFields
            }
            setLoading(true)
            api.post('/association/production/loan/setup', data,{
                headers: {
                    Authorization:'Bearer ' + fetchToken(),
                },
            }).then(function (response){
                setMessage(response.data);
                setOpe(true);
                handleFarmersClose();
                fetchProducts();
            }).catch(function (error){
                console.log(error);
            }).finally(function(){
                setLoading(false);
            })
        }
    });

    useEffect(() => {
        if(formik.values.society_id){
            api.get(`/commodity/type/commodities/${formik.values.society_id}`, {
                headers: {
                    Authorization:'Bearer ' + fetchToken(),
                },
            }).then(function (response){
                setCommodities(response.data?.Commodities);
                setCommodities_ready(false)
            }).catch(function (error){
                console.log(error);
            })
        }
    },[formik.values.society_id])




    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1400,
        maxHeight: '80vh', 
        overflowY: 'auto', 
        '&::-webkit-scrollbar': {
            width: '7px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
        bgcolor: 'background.paper',
        border: '1px solid #e7ecef',
        borderRadius: '7px',
        boxShadow: 24,
        p: 4,
      };

      const edit_style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 520,
        maxHeight: '80vh', 
        overflowY: 'auto', 
        '&::-webkit-scrollbar': {
            width: '7px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
        bgcolor: 'background.paper',
        border: '1px solid #e7ecef',
        borderRadius: '7px',
        boxShadow: 24,
        p: 4,
      };

    const handleClo = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpe(false);
    };


    const actio = (
        <React.Fragment>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClo}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      );
    

    const handleClickOpen = () => {
        setOpen(true);
    };
    
    const handleClose = () => {
        setOpen(false);
    };

    const handleEditOpen = (id, name, type, price, crop_id, interest, quantity, company) => {
        setE_Id(id);
        setE_Name(name);
        setE_Type(type);
        setE_Price(price);
        setEdit_open(true);
        setCrop_id(crop_id);
        setE_Interest(interest);
        setE_Quantity(type === 'input'? quantity: 0);
        setE_Company(type === 'input'? company: '');
    };
    
    const handleEditClose = () => {
        setEdit_open(false);
        setE_Id(null);
        setE_Type('');
        setE_Name('');
        setE_Price(null);
        setE_Interest(null);
        setE_Quantity(0);
        setE_Company('');
    };

    const handleFarmersOpen = () => {
        setModal_open(true);
    };
    
    const handleFarmersClose = () => {
        setModal_open(false);
        formik.handleReset();
        setServiceFields([
            {
              index_id: 0,
              service_name: '', 
              service_price: null
            },
        ]);
        setInputFields([
            {
                index_id: 0,
                input_name: '', 
                input_price: null,
                input_quantity: null,
                input_company: ''
            },
        ]);
        setEquipmentsFields([
            {
                index_id: 0,
                equipment_name: '', 
                equipment_price: null
            },
        ]);
        setCommodities_ready(true);
    };


    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        if (type === 'checkbox') {
            setLoansData({
                ...loansData,
                [name]: checked,
            });
        } else {
            setLoansData({
                ...loansData,
                [name]: value,
            });
        }
    };

    
    const getLoansAccount =  () => {
        toast.promise(
            api.get("/account/loan/hh", {
              headers: {
                Authorization: "Bearer " + fetchToken(),
              },
            }),
            {
              loading: "Loading Info...",
              success: (response) => {
                setAllSLoans(response.data);
      
                return "Successfully Loaded";
              },
              error: (error) => {
                console.log(error);
                return "An error Occurred, try again later";
              },
            }
          );
    }


    useEffect(() => {
        getLoansAccount();
    }, [])


    const loansColumns = [
        {
            field: "id",
            headerName: "ID",
            flex: 1,
            cellClassName: "name-column--cell",
        },
        {
            field: "account_name",
            headerName: "Account Name",
            flex: 1,
            cellClassName: "name-column--cell",
        },
        {
            field: "interest_amt",
            headerName: "Interest Percentage (%)",
            flex: 1,
        },
        {
            field: "application_fee",
            headerName: "Application Fee(%)",
            flex: 1,
        },
        {
            field: "proccessing_fee",
            headerName: "Processing Fee(%)",
            flex: 1,
        },
        {
            field: "min_amt",
            headerName: "Minimum Amount",
            flex: 1,
        },
        {
            field: "max_amt",
            headerName: "Maximum Amount",
            flex: 1,
        },
        {
            field: "in_out",
            headerName: "Inflow/Outflow",
            flex: 1,
          },
          {
            field: "in_ex",
            headerName: "Inflow/Expenditure",
            flex: 1,
          },
          {
            field: "as_li",
            headerName: "Asset/Liability",
            flex: 1,
          },
        {
            field: "update",
            type:'action',
            headerName: "Action",
            flex: 1,
            renderCell: (params) => <AccountActions {...{params, getLoansAccount}} />
        },
        {
          field: "actions",
          headerName: "Open",
          type: "actions",
          flex: 1,
          getActions: (params: GridRowParams) => [
            <GridActionsCellItem
              icon={<FileOpenOutlined />}
              onClick={() => takeMe(params.row.id)}
              label="Open"
            />,
          ],
        },
    ];

    const takeMe = (id) => {
        navigate("/loans/account", { state: { id: id, accounts: allLoans } });
      };

    const createLoans = async (event) => {
        event.preventDefault();
             await api.post('/account/loan', loansData, {
                headers: {
                    Authorization: 'Bearer '+ fetchToken()
                }
             }).then(function (response) {
                    setMessage(response.data)
                    setOpe(true)
                    setLoansData({
                        "id": null,
                        "account_name": '',
                        "interest_amt": null,
                        "application_fee": null,
                        "proccessing_fee": null,
                        "min_amt": null,
                        "max_amt": null,
                        "in_out": "",
                        "in_ex": "",
                        "as_li": "",
                    })
                    setOpen(false);
                    getLoansAccount();
             }).catch(function (error){
                console.log(error)
             })
    }
    const currencyFormat = new Intl.NumberFormat('en-GH', {
      style: 'currency',
      currency: 'GHS',
    });

    const removeThing = (id, type) => {
        const data = new FormData()
        data.append('id', id)
        data.append('typee', type)

        api.post('/association/production/loan/delete/service/input', data, {
            headers: {
                Authorization:'Bearer ' + fetchToken(),
            },
        }).then(function (response){
            setMessage(response.data);
            setOpe(true);
            fetchProducts();
        }).catch(function (error){
            console.log(error);
        })
    }

    const SaveEdit = () => {
        if(e_id){
            const data = new FormData()
            data.append('id', e_id)
            data.append('name', e_name)
            data.append('typee', e_type)
            data.append('price', e_price)
            data.append('interest', e_interest)
            data.append('quantity', e_quantity)
            data.append('company', e_company)
            setLoading(true);
            api.post('/association/production/loan/edit/service/input', data, {
                headers: {
                    Authorization:'Bearer ' + fetchToken(),
                },
            }).then(function (response){
                setMessage(response.data);
                setOpe(true);
                fetchProducts();
                handleEditClose();
            }).catch(function (error){
                console.log(error);
            }).finally(function () {
                setLoading(false)
            })
        }else{
            const data = new FormData()
            data.append('crop_id', crop_id)
            data.append('name', e_name)
            data.append('typee', e_type)
            data.append('price', e_price)
            data.append('interest', e_interest)
            data.append('quantity', e_quantity)
            data.append('company', e_company)
            setLoading(true);
            api.post('/association/production/loan/add/service/input', data, {
                headers: {
                    Authorization:'Bearer ' + fetchToken(),
                },
            }).then(function (response){
                setMessage(response.data);
                setOpe(true);
                fetchProducts();
                handleEditClose();
            }).catch(function (error){
                console.log(error);
            }).finally(function () {
                setLoading(false)
            })
        }
        
    }

    

    return(
        <>
                <Card sx={{ minWidth: 280, margin: 4 }}>
                <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                    Loans Account
                </Typography>
                {
                    permissions && permissions.create_loan_account === true ?
                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                        <Button variant="outlined" sx={{ m:1 }} onClick={handleClickOpen}>Setup Cash Loans</Button>
                        <Button variant="outlined" sx={{ m:1 }} onClick={handleFarmersOpen}>Setup Farmers Loans</Button>
                    </Typography>
                    :
                    null
                }
                    
                </CardContent>
                <CardActions>
                <Button>
                
                </Button>
                </CardActions>
        </Card>
        <Divider variant="middle" />
        <Typography
            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            variant='h3'
            textAlign='center'
            sx={{ color: 'black' }}
        >
            <b>Production and Equipment Loans Products</b>
        </Typography>
        <Button
            variant='contained'
            size='small'
            onClick={handleClick}
            sx={{   m:1, 
                borderRadius:4,
                backgroundColor:'#eb5e28',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                minWidth: 0,
                '&:hover': {
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                    backgroundColor:'#bc6c25',
                    color:'#000'
                },
            }} 
            id="demo-positioned-button"
            aria-controls={oppen ? 'demo-positioned-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={oppen ? 'true' : undefined}
        >
            Setup Seasons
        </Button>
        <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={oppen}
            onClose={handleCloses}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
            }}
        >
            {
                all_societies.map((item)=>(
                    <MenuItem onClick={() => handleConfirm(item.id, item.society)}>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{item.society}</b>
                        </Typography>
                    </MenuItem>
                ))
            }
            <MenuItem onClick={handleCloses}>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Cancel</b>
                </Typography>
            </MenuItem>
        </Menu>
        {
            products[0]?
            <Box sx={{ display:'flex', marginBottom:20, flexWrap:'wrap', maxHeight: 550, overflowY: 'auto', '&::-webkit-scrollbar': {
                    width: '7px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: '#888',
                        borderRadius: '10px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        background: '#555',
                }}}
        >
            <Grid container spacing={2}>
                {
                products && products.map((one) => (
                    <Grid item xs={12} md={6} key={one.id}>
                        <Card sx={{ m:1, backgroundColor:'#e7d8c9', width: '100%'}}>
                            <CardHeader
                                title={<Typography variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{one.commodity_name}</b></Typography>}
                                subheader={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'><b>{one.society}</b></Typography>}
                            />
                            <CardContent>
                            <Accordion sx={{ borderRadius:2, marginBottom:3 }}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Typography
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        subtitle='h5'
                                        sx={{ color: 'black' }}
                                    ><b>View current setup</b></Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ maxHeight: 200, overflowY: 'auto', '&::-webkit-scrollbar': {
                                                            width: '7px',
                                                            },
                                                            '&::-webkit-scrollbar-track': {
                                                                background: '#f1f1f1',
                                                            },
                                                            '&::-webkit-scrollbar-thumb': {
                                                                background: '#888',
                                                                borderRadius: '10px',
                                                            },
                                                            '&::-webkit-scrollbar-thumb:hover': {
                                                                background: '#555',
                                                        } }}>
                                    <Grid container>
                                        <Grid item xs={12} md={12}>
                                            <ul><Typography sx={{ color:'#22223b', textDecoration:'underline' }} variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Services setups</b>
                                            <Button sx={{ m:1, backgroundColor:'#33415c', borderRadius:4 }} size="small" onClick={() =>handleEditOpen(null, '', 'service', null, one.commodity_id, null, null, '')} variant="contained">Add service</Button>
                                            </Typography>
                                            
                                                {
                                                    one.services.map((service) =>(
                                                        <li>
                                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                <b>{service.service}: {currencyFormat.format(service.service_price_per_acre)} per acre | {service.interest_percentage_rate_anum}% interest rate/anum </b> 
                                                                <IconButton  onClick={() => removeThing(service.id, 'service')}><RemoveCircleIcon /></IconButton>
                                                                <Button sx={{ m:1, backgroundColor:'#eb5e28', borderRadius:4 }} size="small" onClick={() =>handleEditOpen(service.id, service.service, 'service', service.service_price_per_acre, one.commodity_id, service.interest_percentage_rate_anum, null, '')} variant="contained">Edit</Button>
                                                            </Typography>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <ul><Typography sx={{ color:'#22223b', textDecoration:'underline' }} variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Inputs setups</b>
                                            <Button sx={{ m:1, backgroundColor:'#33415c', borderRadius:4 }} size="small" onClick={() =>handleEditOpen(null, '', 'input', null, one.commodity_id, null, '')} variant="contained">Add Input</Button>
                                            </Typography>
                                            
                                                {
                                                    one.inputs.map((input) =>(
                                                        <li>
                                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                <b>({input.company}) | {input.input}: {currencyFormat.format(input.input_price_per_acre)} per acre | {input.interest_percentage_rate_anum}% interest rate/anum | {input.quantity_per_acre}(g/kg/liters/bottle) per acre </b>
                                                                <IconButton  onClick={() => removeThing(input.id, 'input')}><RemoveCircleIcon /></IconButton>
                                                                <Button sx={{ m:1, backgroundColor:'#eb5e28', borderRadius:4 }} size="small" onClick={() =>handleEditOpen(input.id, input.input, 'input', input.input_price_per_acre, one.commodity_id, input.interest_percentage_rate_anum, input.quantity_per_acre, input.company)} variant="contained">Edit</Button>
                                                            </Typography>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </Grid>

                                        <Grid item xs={12} md={12}>
                                            <ul><Typography sx={{ color:'#22223b', textDecoration:'underline' }} variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Equipments setups</b>
                                            <Button sx={{ m:1, backgroundColor:'#33415c', borderRadius:4 }} size="small" onClick={() =>handleEditOpen(null, '', 'equipment', null, one.commodity_id, null, '')} variant="contained">Add Equipment</Button>
                                            </Typography>
                                            
                                                {
                                                    one.equipments.map((equipment) =>(
                                                        <li>
                                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                <b>{equipment.equipment}: {currencyFormat.format(equipment.equipment_price_per_acre)} per acre | {equipment.interest_percentage_rate_anum}% interest rate/anum </b>
                                                                <IconButton  onClick={() => removeThing(equipment.id, 'equipment')}><RemoveCircleIcon /></IconButton>
                                                                <Button sx={{ m:1, backgroundColor:'#eb5e28', borderRadius:4 }} size="small" onClick={() =>handleEditOpen(equipment.id, equipment.equipment, 'equipment', equipment.equipment_price_per_acre, one.commodity_id, equipment.interest_percentage_rate_anum, null, '')} variant="contained">Edit</Button>
                                                            </Typography>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                                </Accordion>
                            </CardContent>
                            <CardActions>
                                <Tooltip title="View Loan Products">
                                    <IconButton><OpenInNewIcon /></IconButton>
                                </Tooltip>
                            </CardActions>
                        </Card>
                    </Grid>
                        
                ))
            }
            </Grid>
            
        </Box>:
            <Typography
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                textAlign='center'
            >
                <b>Loans products will display here </b> 
                <CircularProgress size={10}/>
            </Typography>
        }
        
        
        <Divider variant="middle" sx={{ mb:5 }}/>
        <Typography
            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            variant='h3'
            textAlign='center'
            sx={{ color: 'black' }}
        >
            <b>Cash Loans Products</b>
        </Typography>
        <Box
            m="40px 0 0 0"
            height="75vh"
            paddingBottom="35px"
            sx={{ 
                "& .MuiDataGrid-virtualScroller": {
                    backgroundColor: "white",
                },
                }}
        >
            <DataGrid
                rows={allLoans}
                columns={loansColumns}
                checkboxSelection
                slots={{ toolbar: GridToolbar}}
            />
        </Box>

        <Modal
            open={edit_open}
            onClose={handleEditClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={edit_style}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                        <Typography
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            variant='h5'
                            textAlign='center'
                        >
                            <b>Loan Product</b>
                        </Typography>
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                        <TextField 
                            size='small'
                            value={e_name}
                            name='e_name'
                            label={e_type === 'service'? 'Service loan name':e_type === 'input'? 'Input loan name': 'Equipment name'}
                            onChange={e => setE_Name(e.target.value)}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField 
                            size='small'
                            value={e_price}
                            name='e_price'
                            label={e_type === 'service'? 'Service loan price charged/acre':e_type === 'input'? 'Input loan price charged/acre': 'Equipment loan price charged/acre'}
                            onChange={e => setE_Price(e.target.value)}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField 
                            size='small'
                            value={e_interest}
                            name='e_interest'
                            label={e_type === 'service'? 'Service interest rate/anum':e_type === 'input'? 'Input interest rate/anum': 'Equipment interest rate/anum'}
                            onChange={e => setE_Interest(e.target.value)}
                        />
                    </Grid>

                    {
                        e_type === 'input'?
                        <>
                        <Grid item xs={12} md={6}>
                        <TextField 
                            size='small'
                            value={e_quantity}
                            name='e_quantity'
                            label={`Number of ${e_name}/acre`}
                            onChange={e => setE_Quantity(e.target.value)}
                        />
                        </Grid>

                        <Grid item xs={12} md={6}>
                        <TextField 
                            size='small'
                            value={e_company}
                            name='e_company'
                            label='Source company'
                            onChange={e => setE_Company(e.target.value)}
                        />
                        </Grid>
                        </>
                    :
                    null
                    }
                    
                    <Grid item xs={12} md={12}>
                        <Button sx={{ m:1, backgroundColor:'#660708', borderRadius:4 }} size="small" onClick={handleEditClose} variant="contained">Cancel</Button>
                        <Button sx={{ m:1, backgroundColor:'#33415c', borderRadius:4 }} size="small" onClick={SaveEdit} variant="contained">{loading? <CircularProgress size={20}/> :'Save'}</Button>
                    </Grid>
                </Grid>
            </Box>
        </Modal>
        <Modal
            open={modal_open}
            onClose={handleFarmersClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={12}>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='h4' textAlign='center'>
                            <b>Farmers Loan</b>
                        </Typography>
                    </Grid>
                 
                    <Grid item xs={12} md={12}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={all_societies}
                            fullWidth
                            getOptionLabel={(option) => option.society}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            onChange={(event, value) => {
                                if (value) {
                                    formik.setFieldValue("society_id", value.id)
                                }
                            }}
                            renderInput={(params) => <TextField {...params} label="Select Society" size="small" />}
                        />
                    </Grid>

                    <Grid item xs={12} md={12}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={commodities}
                            disabled={commodities_ready}
                            fullWidth
                            getOptionLabel={(option) => option.commodity}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            onChange={(event, value) => {
                                if (value) {
                                    formik.setFieldValue("crop_id", value.id)
                                }
                            }}
                            renderInput={(params) => <TextField {...params} label="Select Crop"  size="small" />}
                        />
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={12}>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='h5' textAlign='center'>
                                    <b>Production Loans</b>
                                </Typography>
                        <Divider variant="middle" />
                            </Grid>
                        
                        <Grid item xs={12} md={6}>
                        {/* Service loan */}
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='h6' textAlign='center'>
                            <b>Services</b>
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'space-around'}}>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" textAlign='left'>
                                <b>service name</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" textAlign='right'>
                                <b>service price/acre</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" textAlign='right'>
                                <b>interest rate &/anum</b>
                            </Typography>
                        </Box>
                        {
                            serviceFields.map((service, index) => (
                                <Box key={service.index_id} sx={{ display: 'flex', justifyContent: 'space-around'}}>
                                    <TextField
                                        size='small'
                                        name='service_name'
                                        sx={{ m:1 }}
                                        onChange={(event) => {
                                            const updatedServiceFields = serviceFields.map((item) => {
                                              if (item.index_id === service.index_id) {
                                                return {
                                                  ...item,
                                                  service_name: event.target.value
                                                };
                                              }
                                              return item;
                                            });
              
                                            setServiceFields(updatedServiceFields);
                                          }}
                                    />
                                    <TextField
                                        size='small'
                                        name='service_price'
                                        sx={{ m:1 }}
                                        type='number'
                                        onChange={(event) => {
                                            const updatedServiceFields = serviceFields.map((item) => {
                                              if (item.index_id === service.index_id) {
                                                return {
                                                  ...item,
                                                  service_price: event.target.value
                                                };
                                              }
                                              return item;
                                            });
              
                                            setServiceFields(updatedServiceFields);
                                          }}
                                    />
                                    <TextField
                                        size='small'
                                        name='service_interest'
                                        sx={{ m:1 }}
                                        type='number'
                                        onChange={(event) => {
                                            const updatedServiceFields = serviceFields.map((item) => {
                                              if (item.index_id === service.index_id) {
                                                return {
                                                  ...item,
                                                  service_interest: event.target.value
                                                };
                                              }
                                              return item;
                                            });
              
                                            setServiceFields(updatedServiceFields);
                                          }}
                                    />
                                    <IconButton disabled={serviceFields.length > 1?false:true} onClick={() => removeServiceField(service.index_id)}><RemoveCircleIcon /></IconButton>
                                </Box>
                            ))
                        }
                        <Button sx={{ m:1, backgroundColor:'#33415c', borderRadius:4 }} size="small" onClick={addServiceFields} variant="contained">New Service</Button>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        {/* Input loan */}
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='h6' textAlign='center'>
                            <b>Inputs</b>
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'space-around'}}>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" textAlign='left'>
                                <b>input</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" textAlign='right'>
                                <b>price/acre</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" textAlign='right'>
                                <b>interest rate/anum</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" textAlign='right'>
                                <b>quantity/acre</b>
                            </Typography>
                        </Box>
                            {
                                inputFields.map((input, index) => (
                                    <Box key={input.index_id}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-around'}}>
                                            <TextField
                                                size='small'
                                                name='input_name'
                                                label='Input name'
                                                sx={{ m:1 }}
                                                onChange={(event) => {
                                                    const updatedInputFields = inputFields.map((item) => {
                                                        if (item.index_id === input.index_id) {
                                                            return {
                                                                ...item,
                                                                input_name: event.target.value
                                                            };
                                                        }
                                                        return item;
                                                    });
                                                    setInputFields(updatedInputFields);
                                                }}
                                            />
                                            <TextField
                                                size='small'
                                                name='input_price'
                                                label='Price per acre'
                                                sx={{ m:1 }}
                                                type='number'
                                                onChange={(event) => {
                                                    const updatedInputFields = inputFields.map((item) => {
                                                        if (item.index_id === input.index_id) {
                                                            return {
                                                                ...item,
                                                                input_price: event.target.value
                                                            };
                                                        }
                                                        return item;
                                                    });
                                                    setInputFields(updatedInputFields);
                                                }}
                                            />
                                            <TextField
                                                size='small'
                                                name='input_interest'
                                                label='Interest rate/anum'
                                                sx={{ m:1 }}
                                                type='number'
                                                onChange={(event) => {
                                                    const updatedInputFields = inputFields.map((item) => {
                                                        if (item.index_id === input.index_id) {
                                                            return {
                                                                ...item,
                                                                input_interest: event.target.value
                                                            };
                                                        }
                                                        return item;
                                                    });
                                                    setInputFields(updatedInputFields);
                                                }}
                                            />
                                            </Box>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-around'}}>
                                            <TextField
                                                size='small'
                                                name='input_quantity'
                                                label='Quantity per acre'
                                                sx={{ m:1 }}
                                                type='number'
                                                onChange={(event) => {
                                                    const updatedInputFields = inputFields.map((item) => {
                                                        if (item.index_id === input.index_id) {
                                                            return {
                                                                ...item,
                                                                input_quantity: event.target.value
                                                            };
                                                        }
                                                        return item;
                                                    });
                                                    setInputFields(updatedInputFields);
                                                }}
                                            />

                                            <TextField
                                                size='small'
                                                name='input_company'
                                                sx={{ m:1 }}
                                                label='Source Company Name'
                                                onChange={(event) => {
                                                    const updatedInputFields = inputFields.map((item) => {
                                                        if (item.index_id === input.index_id) {
                                                            return {
                                                                ...item,
                                                                input_company: event.target.value
                                                            };
                                                        }
                                                        return item;
                                                    });
                                                    setInputFields(updatedInputFields);
                                                }}
                                            />
                                            <IconButton disabled={inputFields.length > 1?false:true} onClick={() => removeInputField(input.index_id)}><RemoveCircleIcon /></IconButton>
                                            </Box>
                                            <Divider sx={{ m: '7px' }} variant="middle" />
                                        </Box>
                                ))
                            }
                        <Button sx={{ m:1, backgroundColor:'#33415c', borderRadius:4 }} size="small" onClick={addInputFields} variant="contained">New Input</Button>
                    </Grid>

                        </Grid>
                    </Grid>
                        
                    

                    <Grid item xs={12} md={4}>
                        {/* Equipment loan */}
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='h5' textAlign='center'>
                            <b>Equipment Loans</b>
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'space-around'}}>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" textAlign='left'>
                                <b>equipment name</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" textAlign='right'>
                                <b>price for equipment</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" textAlign='right'>
                                <b>interest rate &/month</b>
                            </Typography>
                        </Box>
                        {
                            equipmentsFields.map((equipment, index) => (
                                <Box key={equipment.index_id} sx={{ display: 'flex', justifyContent: 'space-around'}}>
                                    <TextField
                                        size='small'
                                        name='equipment_name'
                                        sx={{ m:1 }}
                                        onChange={(event) => {
                                            const updatedEquipmentFields = equipmentsFields.map((item) => {
                                              if (item.index_id === equipment.index_id) {
                                                return {
                                                  ...item,
                                                  equipment_name: event.target.value
                                                };
                                              }
                                              return item;
                                            });
              
                                            setEquipmentsFields(updatedEquipmentFields);
                                          }}
                                    />
                                    <TextField
                                        size='small'
                                        name='equipment_price'
                                        sx={{ m:1 }}
                                        type='number'
                                        onChange={(event) => {
                                            const updatedEquipmentFields = equipmentsFields.map((item) => {
                                              if (item.index_id === equipment.index_id) {
                                                return {
                                                  ...item,
                                                  equipment_price: event.target.value
                                                };
                                              }
                                              return item;
                                            });
              
                                            setEquipmentsFields(updatedEquipmentFields);
                                          }}
                                    />
                                    <TextField
                                        size='small'
                                        name='equipment_interest'
                                        sx={{ m:1 }}
                                        type='number'
                                        onChange={(event) => {
                                            const updatedEquipmentFields = equipmentsFields.map((item) => {
                                              if (item.index_id === equipment.index_id) {
                                                return {
                                                  ...item,
                                                  equipment_interest: event.target.value
                                                };
                                              }
                                              return item;
                                            });
              
                                            setEquipmentsFields(updatedEquipmentFields);
                                          }}
                                    />
                                    <IconButton disabled={equipmentsFields.length > 1?false:true} onClick={() => removeEquipmentField(equipment.index_id)}><RemoveCircleIcon /></IconButton>
                                </Box>
                            ))
                        }
                        <Button sx={{ m:1, backgroundColor:'#33415c', borderRadius:4 }} size="small" onClick={addEquipmentFields} variant="contained">New Equipment</Button>
                    </Grid>

                    {/* buttons */}
                    <Grid item xs={12} md={12}  >
                        <div style={{ display:'flex', m:1 }}>
                            <Button sx={{ m:1, backgroundColor:'red', borderRadius:4 }} size="small" onClick={handleFarmersClose} variant="contained">Close</Button>
                            <Button
                                disabled={serviceFields[0]?.service_name && serviceFields[0]?.service_price && formik.values.crop_id ||
                                          inputFields[0]?.input_name && inputFields[0]?.input_price && inputFields[0]?.input_quantity && inputFields[0]?.input_company && formik.values.crop_id || 
                                          equipmentsFields[0]?.equipment_name && equipmentsFields[0]?.equipment_price && formik.values.crop_id? false:true}
                                sx={{ m:1, borderRadius:4 }} 
                                color="success" 
                                size="small" 
                                onClick={formik.handleSubmit} 
                                variant="contained"
                            >
                                {
                                    loading?
                                    <CircularProgress size={20}/>
                                    : 'Set up'
                                }
                                
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </Box>
        </Modal>

        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Setup Loans Account</DialogTitle>
            <DialogContent>
            <DialogContentText>
                You will be able to open {loansData.account_name} Accounts
                after the setup.
            </DialogContentText>
            <TextField
                required
                margin="dense"
                id="account_name"
                name="account_name"
                label="Account Name"
                onChange={handleInputChange}
                value={loansData.account_name}
                type="text"
                fullWidth
                variant="outlined"
            />
            <TextField
                required
                margin="dense"
                id="interest_amt"
                name="interest_amt"
                type="number"
                value={loansData.interest_amt}
                label="Interest Percentage (%)"
                onChange={handleInputChange}
                fullWidth
                variant="outlined"
            />
            

            <TextField
                required
                margin="dense"
                id="application_fee"
                name="application_fee"
                label="Application Fee (%)"
                onChange={handleInputChange}
                type="number"
                value={loansData.application_fee}
                fullWidth
                variant="outlined"
            />
            <TextField
                required
                margin="dense"
                id="proccessing_fee"
                name="proccessing_fee"
                label="Processing Fee (%)"
                onChange={handleInputChange}
                type="number"
                value={loansData.proccessing_fee}
                fullWidth
                variant="outlined"
            />
            <TextField
                required
                margin="dense"
                id="min_amt"
                name="min_amt"
                label="Minimum Amount"
                onChange={handleInputChange}
                type="number"
                value={loansData.min_amt}
                fullWidth
                variant="outlined"
            />
            <TextField
                required
                margin="dense"
                id="max_amt"
                name="max_amt"
                label="Maximum Amount"
                onChange={handleInputChange}
                type="number"
                value={loansData.max_amt}
                fullWidth
                variant="outlined"
            />
            <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Inflow/Outflow"
                  id="in_out"
                  label="Inflow/Outflow"
                  value={loansData.in_out}
                  onChange={handleInputChange}
                  fullWidth
                  name="in_out"
                >
                    <MenuItem value={'inflow'}>
                      Inflow
                    </MenuItem>
                    <MenuItem value={'outflow'}>
                      Outflow
                    </MenuItem>
                </Select>
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Income/Expenditure"
                  id="in_ex"
                  label="Income/Expenditure"
                  value={loansData.in_ex}
                  onChange={handleInputChange}
                  fullWidth
                  name="in_ex"
                >
                    <MenuItem value={'income'}>
                      Income
                    </MenuItem>
                    <MenuItem value={'expenditure'}>
                      Expenditure
                    </MenuItem>
                    <MenuItem value={'stock'}>
                      Stock
                    </MenuItem>
                </Select>
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Asset/Liability"
                  id="as_li"
                  label="Asset/Liability"
                  value={loansData.as_li}
                  onChange={handleInputChange}
                  fullWidth
                  name="as_li"
                >
                    <MenuItem value={'asset'}>
                      Asset
                    </MenuItem>
                    <MenuItem value={'liability'}>
                      Liability
                    </MenuItem>
                </Select>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={createLoans}>Finish</Button>
            </DialogActions>
        </Dialog>
            <Snackbar
                open={ope}
                autoHideDuration={6000}
                onClose={handleClo}
                message={message}
                action={actio}
            />
                </>

    );
}

export default LoanAccounts;